/* stylelint-disable no-descending-specificity */
import { Flex, icons, responsiveStyles } from '@inlight-media/linfox-ui-library';
import styled from 'styled-components';

const { mobileOnly, desktopOnly } = responsiveStyles;
const { Download } = icons;

const MILESTONE_SQUARE_HEIGHT_MOBILE = '80px';
const SQUARE_WIDTH = '25%';
const CIRCLE_SIZE_MOBILE = '24px';
const CIRCLE_SIZE = '30px';

const Wrapper = styled(Flex)`
  background-color: ${({ theme }) => theme.colors.white};
  height: 255px;
  align-items: center;
  position: relative;
  margin-bottom: ${({ theme }) => theme.space.lg};

  ${mobileOnly} {
    font-size: ${({ theme }) => theme.fontSize.small};
    height: 280px;
    flex-direction: column;
    margin-bottom: 20px;
  }
`;

const MilestoneWrapper = styled.div`
  width: ${SQUARE_WIDTH};
  height: 255px;
  z-index: 1;
  position: absolute;
  left: calc(${SQUARE_WIDTH} * ${({ index }) => index});
  ${({ hideMilestoneDueToCancelledShipment }) => hideMilestoneDueToCancelledShipment && 'display: none;'}

  ${mobileOnly} {
    left: 0;
    top: calc(calc(${MILESTONE_SQUARE_HEIGHT_MOBILE}) * ${({ index }) => index});
    height: ${MILESTONE_SQUARE_HEIGHT_MOBILE};
    width: 100%;
  }
`;

const MilestoneInnerWrapper = styled.div`
  border-radius: 10px;
  border: 2px solid transparent;
  ${({ isCurrentMilestone, theme }) =>
    isCurrentMilestone &&
    `border-color: ${theme.colors.successNine};
     background-color: ${theme.colors.currentMilestoneBackground};`};
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${mobileOnly} {
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    height: 63px;
  }
`;

const ColumnWrapper = styled(Flex)`
  flex-direction: column;
  height: 100%;
  padding: 5px 0;
  justify-content: space-evenly;
`;

const Circle = styled.div`
  width: ${CIRCLE_SIZE};
  height: ${CIRCLE_SIZE};
  border-radius: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 2px solid ${({ theme }) => theme.colors.greyFour};

  svg {
    fill: ${({ theme }) => theme.colors.greyFour};
  }

  ${mobileOnly} {
    width: ${CIRCLE_SIZE_MOBILE};
    height: ${CIRCLE_SIZE_MOBILE};

    > svg {
      transform: scale(0.8);
    }
  }
`;

const InPastCircle = styled(Circle)`
  background-color: ${({ theme }) => theme.colors.successNine};
  border: 2px solid ${({ theme }) => theme.colors.successNine};

  svg {
    fill: ${({ theme }) => theme.colors.white};
  }
`;

const CancelledCircle = styled(Circle)`
  background-color: ${({ theme }) => theme.colors.dangerSix};
  border: 2px solid ${({ theme }) => theme.colors.dangerSix};
`;

const CircleWrapper = styled.div`
  background-color: ${({ theme }) => theme.colors.white};
  ${({ isCurrentMilestone }) => isCurrentMilestone && 'background: none'};
  padding: 5px;

  ${mobileOnly} {
    padding: 8px;
    padding-right: 12px;
  }
`;

const buildLineBorderStyles = ({ milestoneIsInFuture, showCancelledLine, theme }, borderDirection) => `
  border-${borderDirection}: 2px solid ${theme.colors.successNine};

  ${
    milestoneIsInFuture &&
    `border-${borderDirection}: 2px dashed ${theme.colors.greyFour};
  `
  };

  ${
    showCancelledLine &&
    `border-${borderDirection}: 2px solid ${theme.colors.dangerSix};
  `
  };
`;

const Line = styled(Flex)`
  position: absolute;
  z-index: 0;

  ${mobileOnly} {
    ${(props) => buildLineBorderStyles(props, 'left')};
    height: ${MILESTONE_SQUARE_HEIGHT_MOBILE};
    left: calc(calc(${CIRCLE_SIZE_MOBILE} / 2) + 10px);
    top: calc(calc(${MILESTONE_SQUARE_HEIGHT_MOBILE} * ${({ index }) => index - 1}) + 2px);
  }

  ${desktopOnly} {
    ${(props) => buildLineBorderStyles(props, 'top')};
    width: ${SQUARE_WIDTH};
    margin-left: calc(${`-${SQUARE_WIDTH}`} / 2);
    left: calc(${SQUARE_WIDTH} * ${({ index }) => index});
  }
`;

const SubSection = styled.div`
  height: 70px;
  display: flex;
  align-items: center;

  ${mobileOnly} {
    height: auto;
  }
`;

const StyledDownloadIcon = styled(Download)`
  width: 15px;
  height: 15px;

  fill: ${({ theme }) => theme.colors.interactionSix};
`;
const DateWrapper = styled.span`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  color: ${({ theme }) => theme.colors.greyFive};
  font-size: ${({ theme }) => theme.fontSize.xSmall};

  ${mobileOnly} {
    flex-direction: row;
    font-size: ${({ theme }) => theme.fontSize.small};
  }
`;

export {
  CancelledCircle,
  Circle,
  CircleWrapper,
  ColumnWrapper,
  DateWrapper,
  StyledDownloadIcon,
  InPastCircle,
  Line,
  MilestoneInnerWrapper,
  MilestoneWrapper,
  SubSection,
  Wrapper,
};
